import SchemaPage from "../../../../src/components/schema";
import * as React from 'react';
export default {
  SchemaPage,
  React
};